// extracted by mini-css-extract-plugin
export var map_box = "style-module--map_box--72c36";
export var map_group = "style-module--map_group--a60fb";